export default "__VITE_ASSET__Dhpk7$87__"